import { useInfiniteQuery, useQuery } from 'react-query'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type ProjectDomain } from '../../../../types/domain/project-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

export const fetchProjects = async (filters: FiltersDomain) => {
  const queryParams = getQueryStrinfied(getValidFilters(filters))
  const response = await api.get<PaginationDomain<ProjectDomain>>(`/projects?&${queryParams}`)

  return response.data
}

export const fetchFiledProjects = async (filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))
  const { data } = await api.get<PaginationDomain<ProjectDomain>>(`/projects?${query}`)

  return data
}

export const fetchProjectById = async (id: number) => {
  const response = await api.get<ProjectDomain>(`/projects/${id}`)
  return response.data
}

export const useProjectsQuery = () => {
  // return useQuery('projects', () => fetchProjects(), { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true })
}

export const useFiledProjectsQuery = (filters: FiltersDomain) => {
  return useQuery(
    ['filed-projects', filters],
    () => fetchFiledProjects(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true }
  )
}

export const useProjectByIdQuery = (id: number) => {
  return useQuery(['project', id], () => fetchProjectById(id),
    {
      staleTime: 1000 * 60 * 60 * 1 /* 1 hour */,
      keepPreviousData: true,
    },
  )
}

export const useInfiniteProjectsQuery = (filters: any) => {
  return useInfiniteQuery(
    ['projects'],
    ({ pageParam = 1 }) => fetchProjects({ ...filters, page: pageParam }),
    {
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}
